import { cn } from '../../lib/cn'

interface LoadingSpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeMap = {
  sm: 'h-4 w-4 border-[2px]',
  md: 'h-8 w-8 border-[3px]',
  lg: 'h-10 w-10 border-[3px]',
}

export function LoadingSpinner({
  className,
  size = 'md',
}: LoadingSpinnerProps) {
  return (
    <span
      aria-label="Loading"
      className={cn(
        'block animate-spin rounded-full border-black/15 border-t-black/55',
        sizeMap[size],
        className,
      )}
    />
  )
}
